module.exports = __webpack_public_path__ + "images/marketing_site/fb-mailer-2026.png";